import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  taskId: null,
  status: 'idle', // 'idle' | 'processing' | 'completed' | 'failed'
  result: null,
  error: null,
  formData: {
    url: '',
    searchType: 'image', // 'image' | 'text' | 'screenshot'
    imageUrl: '',
    text: ''
  },
  claimId: null, // ID заявки в новой системе
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    startTask: (state, action) => {
      state.taskId = action.payload.task_id;
      state.claimId = action.payload.claimId || null;
      state.status = 'processing';
      state.result = {
        task_id: action.payload.task_id,
        download_url: action.payload.download_url,
        status_url: action.payload.status_url,
        mhtml_view_url: action.payload.mhtml_view_url,
        mhtml_download_url: action.payload.mhtml_download_url,
        protocol_number: action.payload.protocol_number,
        protocol_date: action.payload.protocol_date,
        search_type: state.formData.searchType 
      };
      state.error = null;
    },
    updateTask: (state, action) => {
      const { status, result, error } = action.payload;
      if (status) {
        state.status = status;
      }
      if (result) {
        // Сохраняем все существующие поля и обновляем только те, что пришли в result
        // Важно: сохраняем важные поля из предыдущего состояния, если они не пришли в обновлении
        const existingResult = state.result || {};
        state.result = {
          ...existingResult,
          ...result,
          // Сохраняем важные поля из предыдущего состояния, если они не пришли в новом result
          task_id: result.task_id !== undefined ? result.task_id : existingResult.task_id,
          protocol_number: result.protocol_number !== undefined ? result.protocol_number : existingResult.protocol_number,
          protocol_date: result.protocol_date !== undefined ? result.protocol_date : existingResult.protocol_date,
          search_type: result.search_type !== undefined ? result.search_type : existingResult.search_type,
        };
      }
      if (error !== undefined) {
        state.error = error;
      }
    },
    resetTask: (state) => {
      Object.assign(state, initialState);
    },
    resetScreenshotFile: (state) => {
      if (state.formData.searchType === 'screenshot') {
        // Можно добавить логику очистки специфичных для скриншота данных
      }
    }
  }
});

export const { 
  setFormData, 
  startTask, 
  updateTask, 
  resetTask,
  resetScreenshotFile
} = taskSlice.actions;

export default taskSlice.reducer;

